import { useMemo } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'

import { hasUnreadMessages } from '../../utils/entities/chatRoom'

const BLUE = 'rgb(60, 141, 188)'

const ShiftMessagingDot = ({ offsetX = 0, shift, status }) => {
  const color = useMemo(() => {
    let color = 'grey'

    if (shift && shift.chatRooms && shift.chatRooms.length > 0) {
      color = hasUnreadMessages(shift.chatRooms[0]) ? 'red' : BLUE
    } else if (status === 1) {
      color = BLUE
    } else if (status === 2) {
      color = 'red'
    }

    return color
  }, [shift, status])

  return (
    <div style={{ position: 'absolute', top: '-8px', left: 'calc(100% - 5px)', zIndex: 1 }}>
      <FontAwesomeIcon icon={faCircle} color={color} size='sm' />
    </div>
  )
}

export default ShiftMessagingDot
